import React from 'react';
import { useI18n } from '../../../contexts/I18nContext';
import { DeviceDetailCore } from '../useDeviceDetail';
import { useDevicesDetailsConf } from './useDevicesDetailsConf';
import { JsonPanel } from './JsonPanel';

interface Props {
  core: DeviceDetailCore;
  /** The panel only fetches once it is shown. */
  active: boolean;
}

/** What the device itself receives from /v2/conf — the assembled configuration. */
export const DevicesDetailsConf: React.FC<Props> = ({ core, active }) => {
  const { t } = useI18n();
  const c = useDevicesDetailsConf(core, active);

  return (
    <JsonPanel
      title="Device Configuration (v2/conf)"
      data={c.data}
      loading={c.loading}
      loadingLabel={`Loading V2/CONF data${c.strict ? ' (strict)' : ''}...`}
      emptyLabel={t('devices.noV2ConfData')}
      onRefresh={c.refresh}
      refreshTitle={t('devices.refreshConfigurationData')}
    >
      <label
        className="json-panel-toggle"
        title={
          'When on, the backend returns only fields declared on the ' +
          'hardware-type schema + identity metadata (?strict=true).'
        }
      >
        <input type="checkbox" checked={c.strict} onChange={c.toggleStrict} disabled={c.loading} />
        Strict mode
      </label>
    </JsonPanel>
  );
};
